// const URL = "https://stage.myciright.com/Ciright";
const URL = "https://www.myciright.com/Ciright";

const AppConfig = {
    API: {
        ENDPOINT: URL + "/api",
        USER_PROFILE: URL + "/ajaxCall-photo.htm?flag=employeePhoto&compress=0&colorCode=constant&id=",

        SUBSCRIPTION_ID: 9329,
        VERTICAL_ID: 18,
        APP_ID: 2698,
        SPHERE_TYPE_URL: "ciright-scan.htm",
    },
};

// 11208107

export default AppConfig;
